import { FalhaServico } from '../falha-servico';

export class ParticipacaoSocietaria{
    sociedades: Array<Sociedade>;
    falhaServico: FalhaServico;
    constructor(){
        this.sociedades = [];
        this.falhaServico = new FalhaServico();
    }
}

export class Sociedade{
    razaoSocial: string;
    cnpj: string;
    desde: string;
    participacao: string;
    status: string;
    uf: string;
}